import graphql from './graphql';
import { UserListUsersByCourse, CourseContentCount } from './Request';

const mapUsers = (users, totalEvaluations) =>
  users.map(user => [
    user?.User?.fullName,
    user?.User?.Department?.name,
    user?.User?.JobTitle?.name,
    user?.User?.Terminal.name,
    {
      totalLessonsCompletedManual: user?.User?.UserEvaluations?.totalLessonsCompletedManual,
      totalLessonsCompletedAutomatic: user?.User?.UserEvaluations?.totalLessonsCompletedAutomatic,
      totalLessonsCount: totalEvaluations,
    },
    user?.User?.id,
  ]);
const mapCourseTotals = courses => courses?.evaluationCount;
const mapGeneric = array => (array ?? []).map(item => item.name || '');

export const fetchUsers = async ({ courseId, fullName = '', department = null, jobTitle = null, terminal = null }) => {
  const usersObject = await UserListUsersByCourse({
    courseId,
    fullName,
    department,
    jobTitle,
    terminal,
  });
  const courseTotalObject = await CourseContentCount({ courseId });
  const courseTotal = mapCourseTotals(courseTotalObject);
  const users = mapUsers(usersObject, courseTotal);

  return { users };
};

export const fetchDropdownsInformation = async () => {
  const promises = [];
  promises.push(graphql('Department_list', 'name', 'query'));
  promises.push(graphql('JobTitle_list', 'name', 'query'));
  promises.push(graphql('Terminal_list', 'name', 'query'));

  const data = await Promise.all(promises);

  const departments = mapGeneric(data[0].Department_list);
  const jobTitles = mapGeneric(data[1].JobTitle_list);
  const terminals = mapGeneric(data[2].Terminal_list);

  return { departments, jobTitles, terminals };
};

export default { fetchUsers, fetchDropdownsInformation };
